export interface ICertificationRequirementsInput {
    signature: boolean;
    photo: boolean;
    orderPhoto: boolean;
    geocodeStops: boolean;
    restrictToHundredMeters: boolean;
    editClosedVisitStatus: boolean;
}
